export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M20.4 6.111H3.6C1.608 6.111 0 7.75 0 9.778v7.333h4.8V22h14.4v-4.889H24V9.778c0-2.03-1.608-3.667-3.6-3.667zm-3.6 13.445H7.2v-6.112h9.6v6.112zM20.4 11c-.66 0-1.2-.55-1.2-1.222 0-.672.54-1.222 1.2-1.222.66 0 1.2.55 1.2 1.222 0 .672-.54 1.222-1.2 1.222zM19.2 0H4.8v4.889h14.4V0z\" fill=\"#000\" fill-rule=\"nonzero\"/><path d=\"M0-1h24v24H0z\"/></g>",
  "attrs": {
    "width": "24",
    "height": "22",
    "viewBox": "0 0 24 22",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};